import React from 'react'
import classNames from 'classnames'

import Icon from '@/icons'
import Container from '@/container'

const PageTopBar = ({ iconName, text, children, isGold }) => {
  return (
    <div className="relative">
      <div
        className={classNames({
          'pv3 absolute-top': true,
          'bb b--moon-gray bg-near-white': !isGold,
          'gold-gradient white': isGold
        })}>
        <Container>
          <div className="flex items-center">
            <Icon icon={iconName} height="20px" className="mr3" />
            <div className="f9 fw5">{text}</div>
          </div>
        </Container>
      </div>

      {children}
    </div>
  )
}

export default PageTopBar



// WEBPACK FOOTER //
// ./src/components/page-top-bar/page-top-bar.js